import { generateRandomKey } from "../helpers";
import { SET_INDUSTRIES, SET_SECTORS, UPDATE_USER_PROFILE } from "./constants"; // import the SET_SECTORS constant from the constants.js file
import initialState from "./initialState"; // import the initial state from the initialState.js file

// Desc: Reducer for the Redux store
const reducer = (state = initialState, action) => {
  switch (
    action.type // switch statement to check the action type and return the new state
  ) {
    case SET_SECTORS: // case to set the sectors in the state to the payload from the action creator in action.js
      const updatedSectors = action.payload.map((sector) => ({
        ...sector,
        key: generateRandomKey(),
        industries: sector.industries.map((industry) => ({
          ...industry,
          key: generateRandomKey(),
        })),
      }));
      return { ...state, sectors: updatedSectors }; // return the updated state with the new sectors

    case SET_INDUSTRIES: // case to set the industries in the state to the payload from the action creator in action.js
      let stateCopySector = [...state.sectors]; // create a copy of the state
      const payload = action.payload;
      if (stateCopySector && stateCopySector.length > 0) {
        stateCopySector = stateCopySector.map((sector) => {
          if (sector.sector_key === payload.sector_key) {
            const updatedPayload = payload.industries.map((industry) => ({
              ...industry,
              key: generateRandomKey(),
            }));
            return { ...sector, industries: updatedPayload };
          }
          return sector;
        });
      }
      return { ...state, sectors: stateCopySector }; // return the updated state with the new industries

    case UPDATE_USER_PROFILE: // case to update the user profile in the state to the payload from the action creator in action.js
      return { ...state, userProfile: action.payload }; // return the updated state with the new user profile

    default: // default case to return the state as is
      return state;
  }
};

export default reducer;
